import { render, staticRenderFns } from "./SortorderDropdown.vue?vue&type=template&id=3f48cffa&scoped=true&"
import script from "./SortorderDropdown.vue?vue&type=script&lang=js&"
export * from "./SortorderDropdown.vue?vue&type=script&lang=js&"
import style0 from "./SortorderDropdown.vue?vue&type=style&index=0&id=3f48cffa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f48cffa",
  null
  
)

export default component.exports